import React from "react";
import { Card, CardBody, CardSubtitle } from "reactstrap";

const StatCardComponent = ({ data }) => {
    // Determine the border color class based on status

  return (
    <div
      className="col-lg-3 col-md-3 col-6 mt-4"
      style={{ marginBottom: "1.5rem", cursor: "pointer" }}
      key={data.id}
    >
      <Card className="carer-stat-card">
        <CardBody style={{ textAlign: "center", paddingBottom: "0px" }}>
          <div className="car-body-wrapper cards-body">
            <CardSubtitle
              style={{
                padding: "16px 0px 10px 0px",
                color: "#505050",
                fontWeight: 800,
                fontSize: "1rem",
              }}
            >
              {data.stat_title}
            </CardSubtitle>
            <div style={{ color: "#3f51b5", fontWeight: "bold" }}>
              <h3 className="font-weight-bold">{data.stat_value}</h3>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default StatCardComponent;
